/* eslint-disable */
/* eslint-disable no-console */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable no-constant-condition */
import { client, client1, clientCall, albCall } from './client';
import { appConfig } from '../config/app-config';
import { CancelToken } from 'axios';
import { CustomerEligiblePromotionsRequest } from '../utils/rewardsUtilsInterface';
import { withAddressCache } from '../common/addressValidationCache';
import { AddressValidationPayload } from '../common/addressValidationInterface';
//
const QAToken =
  'eyJraWQiOiI3M1BNSjFNQm1ObkVUU3hPZFNqYWVibVRFK0tjZTRvdVwva1ZDT2VNTGgwbz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIydm42dGV0MmhxYmpmbW00ZzdrdDFlNWw4NyIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoicmFjXC9yZWFkIiwiYXV0aF90aW1lIjoxNjM1NTQ1NTY3LCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV84TWJPeUVZRzYiLCJleHAiOjE2MzU1NDkxNjcsImlhdCI6MTYzNTU0NTU2NywidmVyc2lvbiI6MiwianRpIjoiMWI4NjJmZDctZGE0Zi00ZTMwLWJmM2QtMGUwOGQwNDRmMmYwIiwiY2xpZW50X2lkIjoiMnZuNnRldDJocWJqZm1tNGc3a3QxZTVsODcifQ.qOF9aMMN_8nCia6JbsZmUy6wD96wsWPZmZVULqu3bsa7RDctmVH3gbTANOToA-U3xqNGSFL9rMrHU8YmAuEgI9NXtMxcZzOXJrVvV_Zlpq6Kb6FgIRtDOFzOGvuW41aOAzOxL4H7BjLOLzbbIkfWINBUME68NhXyP8ZMDrjP0pw75sqw2peIaMPILQqEJUARNiFaphrMRz267SUo2LIkLFxsq20rE_tgCTkFZ8n_zgUZ5ejJnM92VQkd-2hmp8SCdqalEI4r1Q1vva3mkR8kaLqN2Ef0b_XMj4bMXnbl1DNKPdyi48GknOFD81AonGXqW5hJFxe1LfTOB4H0kcryeA';
//const BaseUrl = 'https://dev-agreement-racpad.rentacenter.com/api';
console.log('AppConfig Urls', appConfig);
const TwoFactorBaseURL = appConfig.apiUrls.storemgmt;
const getCurrentUserBaseURL = appConfig.apiUrls.menu;
const InventoryBaseUrl = appConfig.apiUrls.inventory;
const customerBaseURL = appConfig.apiUrls.customer;
// const salesLeadUATURL = 'https://uat-customer-racpad.rentacenter.com/api';

// const PaymentBaseUrl = 'https://dev-payment1-racpad.rentacenter.com/api';

// eslint-disable-next-line no-console
console.log('app config in user', appConfig);

export const tireBuyerEmailNotification = async (voidobj) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/void/update`,
    { method: 'PUT', body: voidobj },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
}
export const amActivityLogInsertion = async (payload: any) => {
  return await clientCall(
    `customer/logactivity`,
    { method: 'POST', body: payload },
    appConfig.apiUrls.am,
    QAToken,
    true
  );
}

export const getStoreConfigs = async (payload: any) => {
  return await clientCall(
    `config/get-store-profile`,
    { method: 'POST', body: payload },
    appConfig.apiUrls.am,
    QAToken,
    true
  );
}

export const insertAgreementLog = async (Payload: any) => {
  return await clientCall(
    `agreement/activity`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.customer,
    QAToken,
    true
  );
};
export const tireCOCreateAgreement = async (payload: any) => {
  return await clientCall(
    `agreement/customerorder/create`,
    { method: 'POST', body: payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const tireCreateCart = async (payload: any) => {
  return await clientCall(
    `agreement/create/cart`,
    { method: 'POST', body: payload },
    // appConfig.apiUrls.micro,
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getRetentionOffers = async (Payload: any) => {
  return await clientCall(
    `retention/offers`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.customer,
    QAToken,
    true
  );
};

export const getAgreementsByCustomerId = async (customerId: any) => {
  return await clientCall(
    `customer/${customerId}/agreements?inActive=N`,
    { method: 'GET' },
    customerBaseURL,
    QAToken,
    true
  );
};
// store serach service function
export const getStore = async (Payload: any) => {
  return await clientCall(
    `customer/store-search`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.customer,
    QAToken,
    true
  );
};
export const getConfigDetails = async (payload: any) => {
  const TempAccessToken = "QAToken";
  return await clientCall(
    `store-details`,
    { method: "POST", body: payload },
    appConfig.apiUrls.micro,
    TempAccessToken,
    true
  );
};
export const updateEventStatus = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `appointment/action`,
      { method: "POST", body: payload },
      appConfig.apiUrls.storemgmt,
      QAToken,
      true
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
// Manage Agreement Transfer
export const manageAgreementTransfer = async (Payload: any) => {
  return await clientCall(
    `manage/transfer`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
// getAgreementTransferReceive
export const getAgreementTransfer = async (
  storeNum: any,
  transferType: any,
  offset: any
) => {
  return await clientCall(
    `agreement/transfers/${storeNum}?transferType=${transferType}&offset=${offset}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const splitAgreement = async (Payload: any) => {
  return await clientCall(
    `agreement/update/split`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const getCustomerStatesList = (country = 'state_province') =>
    client(`references/entity?referenceCode=${country}`, 
    { method: "GET" },
    appConfig.apiUrls.am,
  );
export const GetCustomerByIdInfo = async (
  customerId: any,
  storeNumber: any
) => {
  try {
    return await clientCall(
      `customer/${customerId}`,
      { method: 'PUT', body: { storeNumber: storeNumber } },
      appConfig.apiUrls.customer,
      QAToken,
    true
    );
  } catch (e: any) {
    return null;
  }
};
export const breakPackage = async (Payload: any) => {
  return await clientCall(
    `/inventory/package/break`,
    { method: 'POST', body: Payload },
    InventoryBaseUrl,
    QAToken,
    true
  );
};
export const getCOpriceQuote = async (Payload: any) => {
  return await clientCall(
    `/agreement/customerorder/quote`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const coCreateAgreement = async (Payload: any) => {
  return await clientCall(
    `agreement/customerorder/create`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const coCancelAgreement = async (payload: any) => {
  return await clientCall(
    `agreement/customerorder/cancel`,
    { method: 'POST', body: payload },
    appConfig.apiUrls.micro,
  );
};

export const getnextpaymentamount = async (Payload: any) => {
  return await clientCall(
    `agreement/getnextpaymentamount`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getAgreementInfo = async (AgreementId: any) => {
  return await clientCall(
    `agreement/${AgreementId}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const UpdateAddressInfo = async (payload: any) => {
  /* eslint-disable no-console */
  console.log('QA TOKEN', QAToken);
  /* eslint-enable no-console */
  /* eslint-enable no-console */
  try {
    const TempAccessToken = QAToken;
    return await clientCall(
      `customer/address/update`,
      { method: 'POST', body: payload },

      customerBaseURL,
      TempAccessToken
    );
  } catch (e: any) {
    return null;
  }
};
export const UpdateActiveClub = async (payload: any) => {
  /* eslint-disable no-console */
  console.log('QA TOKEN', QAToken);
  /* eslint-enable no-console */
  /* eslint-enable no-console */
  try {
    const TempAccessToken = QAToken;
    return await clientCall(
      `customer/activate-club`,
      { method: 'POST', body: payload },

      customerBaseURL,
      TempAccessToken
    );
  } catch (e: any) {
    return null;
  }
};

export const decryptData = async (payload: any) => {
  try {
    return await client(
      `manage/draweraudit`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.cashmgmt,

    );
  } catch (e: any) {
    return null;
  }
};

export const GetCustomerSkipTrace = async (payload: any) => {
  try {
    return await client(
      `customercheck/request/details`,
      { method: 'POST', body: payload },
      customerBaseURL,
    )
  } catch (e: any) {
    return null;
  }
}

export const GetSkipTraceDetails = async (customerId: string)=> {
  try {
    return await client(
      customerBaseURL, `customercheck/${customerId}/details`,
      { method: 'POST' },
    )
  } catch (e: any) {
    return null;
  }
}

export const transferActiveClub = async (payload: any) => {
  /* eslint-disable no-console */
  console.log('QA TOKEN', QAToken);
  /* eslint-enable no-console */
  /* eslint-enable no-console */
  try {
    const TempAccessToken = QAToken;
    return await clientCall(
      `customer/transfer-club`,
      { method: 'POST', body: payload },

      customerBaseURL,
      TempAccessToken
    );
  } catch (e: any) {
    return null;
  }
};
 
export const getPrintDocument = async (payload: any) => {  
  return await clientCall(
    `agreement/document/print`,
    { method: 'POST', body: payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const customerOrderSearch = async (payload: any) => {
  return await clientCall(
    `agreement/customerorder/search`,
    { method: 'POST', body: payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getCustomerPolicy = async (
  agreementId: any,
  customerId: any,
  storeNumber: any
) => {
  return await clientCall(
    `customer/${customerId}/${storeNumber}?agreementId=${agreementId}`,
    { method: 'PUT' },
    customerBaseURL,
    QAToken,
    true
  );
};

export const getPolicyInfo = async (paylaod: any) => {
  /* eslint-disable no-console */
  console.log('getPolicy URL Check', appConfig.apiUrls.micro);

  return await clientCall(
    `agreement/policy`,
    { method: 'POST', body: paylaod },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getRadiusStores = async (storeNumber: any) => {
  return await clientCall(
    `radius-stores/${storeNumber}`,
    {
      method: 'GET',
    },
    TwoFactorBaseURL,
    QAToken,
    true
  );
};

export const getprofileaccess = async (Payload: any) => {
  return await clientCall(
    `store-access`,
    { method: 'POST', body: Payload },
    TwoFactorBaseURL,
    QAToken,
    true
  );
};

export const getPinDetails = async (Payload: any) => {
  return await clientCall(
    `coworker`,
    { method: 'POST', body: Payload },
    TwoFactorBaseURL,
    QAToken,
    true
  );
};

export const getsecondfactor = async (Payload: any) => {
  return await clientCall(
    `coworker-authentication`,
    { method: 'POST', body: Payload },
    TwoFactorBaseURL,
    QAToken,
    true
  );
};

export const getCurrentInfo = async () => {
  return await clientCall(
    `user/current`,
    { method: 'GET' },
    getCurrentUserBaseURL,
    QAToken,
    true
  );
};

export const getSalesInfo = async (salesLeadId: any) => {
  return await clientCall(
    `customer/saleslead/details/${salesLeadId}`,
    { method: 'GET' },
    customerBaseURL,
    QAToken,
    true
  );
};

export const GetCustomer = async (PathParams: any, Payload: any) => {
  return await clientCall(
    `customer/${PathParams}`,
    { method: 'PUT', body: Payload },
    customerBaseURL,
    QAToken,
    true
  );
};
export const getAgreementOptions = async (
  CustomerID: any,
  StoreNumber: any
) => {
  return await clientCall(
    `agreement/options/${CustomerID}?storeNumber=${StoreNumber}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const getSwitchOutAgreementOptions = async (
  CustomerID: any,
  StoreNumber: any
) => {
  return await clientCall(
    `agreement/options/${CustomerID}?storeNumber=${StoreNumber}&isSwitchOut=1`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const getCOAgreementOptions = async (
  CustomerID: any,
  StoreNumber: any
) => {
  return await clientCall(
    `agreement/options/${CustomerID}?storeNumber=${StoreNumber}&isChargeOff=1`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const GetCustomerCoverage = async (
  customerId: any,
  storeNumber: any
) => {
  return await clientCall(
    `customer/${customerId}/${storeNumber}`,
    { method: 'PUT' },
    customerBaseURL,
    QAToken,
    true
  );
};
export const getPriceQuote = async (Payload: any) => {
  return await clientCall(
    `agreement/price/quote`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const GenerateAgreementDoc = async (Payload: any) => {
  return await clientCall(
    `agreement/document/generate`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const CreateAgreement = async (Payload: any) => {
  const customHeaders = {
    headers: { storeNumber: window.sessionStorage.getItem('storeNumber') },
  };
  return await clientCall(
    `agreement/create`,
    { method: 'POST', body: Payload, customHeaders },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const UpdateAgreement = async (Payload: any) => {
  return await clientCall(
    `agreement/switchout/manage`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getInventorySearch = async (payload: any) => {
  return await clientCall(
    'inventory/search',
    { method: 'POST', body: payload },
    InventoryBaseUrl,
    QAToken,
    true
  );
};

export const SendAutopayText = async (Payload: any) => {
  return await clientCall(
    `agreement/autopay`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
export const GetAgreementCustomer = async (Pathparams: any) => {
  return await clientCall(
    `agreement/customers/${Pathparams}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const UpdateVehicleInfo = async (CustomerId, Payload: any) => {
  return await clientCall(
    `customer/${CustomerId}/information`,
    { method: 'PUT', body: Payload },
    customerBaseURL,
    QAToken,
    true
  );
};
export const GetEmployeeID = async () => {
  return await clientCall(
    `user/current`,
    { method: 'GET' },
    getCurrentUserBaseURL,
    QAToken,
    true
  );
};
export const GetRole = async (Payload: any) => {
  return await clientCall(
    `menu-and-stores`,
    { method: 'POST', body: Payload },
    getCurrentUserBaseURL,
    QAToken,
    true
  );
};

export const getAgreementCustomerInfo = async (AgreementId: any) => {
  // eslint-disable-next-line no-console
  console.log('AgreementId', AgreementId);

  return await clientCall(
    `agreement/customers/${AgreementId}`,

    { method: 'GET' },

    appConfig.apiUrls.micro,

    QAToken,

    true
  );
};

export const getVoidOptions = async (CustomerID: any, StoreNumber: any) => {
  return await clientCall(
    `agreement/options/${CustomerID}?storeNumber=${StoreNumber}&isReturn=${0}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getReorderReasonOption = async () => {
  return await clientCall(
    `/agreement/void/reasons `,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getAgreementReturnOptions = async (
  CustomerID: any,
  StoreNumber: any
) => {
  return await clientCall(
    `agreement/options/${CustomerID}?storeNumber=${StoreNumber}&isReturn=${1}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const LoadInventoryInformation = async (inventoryNumber: any) => {
  return await clientCall(
    `inventory/${inventoryNumber}`,
    { method: 'GET' },
    InventoryBaseUrl,
    QAToken,
    true
  );
};

export const CancelPickupStatus = async (voidobj: any) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/void/update`,
    { method: 'PUT', body: voidobj },
    appConfig.apiUrls.micro,
    // 'https://qa-agreement-racpad.rentacenter.com/api',
    TempAccessToken
  );
};
export const getDeliveryMethod = async () => {
  return await client(
    'agreement/delivery/156',
    { method: 'GET' },
    appConfig.apiUrls.micro,
    true
  );
};
export const GetstateDropdown = async (country ?: any) => {
  const TempAccessToken = QAToken;

  return await clientCall(
    `customer/state${country ? `?country=${country}` : ''}`,
    { method: 'GET' },
    customerBaseURL,
    TempAccessToken
  );
};
export const Getreorderreasons = async () => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/reorderreasons`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
export const itemReorder = async (reorderpayload: any) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/customerorder/reorder`,
    { method: 'POST', body: reorderpayload },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
export const GetSuggestedAddress = withAddressCache(async (addressPayload: AddressValidationPayload) => {
  const TempAccessToken = QAToken;

  return await clientCall(
    `customer/address/validate`,
    { method: 'POST', body: addressPayload },
    customerBaseURL,
    TempAccessToken
  );
});

export const GetDeReason = async () => {
  return await clientCall(
    `customer/no-decision-reason`,
    { method: 'GET' },
    customerBaseURL,
    QAToken,
    true
  );
};
export const CoworkerRequired = async (bodyobject: any) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/address/eventId`,
    { method: 'POST', body: bodyobject },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const GetEpodetails = async (bodyobj: any) => {
  const TempAccessToken = QAToken;

  return await client1(
    `agreement/epo`,
    { method: 'POST', body: bodyobj },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
export const GenerateReceipt = async (bodyobj: any) => {
  const TempAccessToken = QAToken;

  return await clientCall(
    `agreement/generatereceipt`,
    { method: 'POST', body: bodyobj },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
export const GenerateSwitchoutReceipt = async (bodyobj: any) => {
  const TempAccessToken = QAToken;

  return await clientCall(
    `agreement/generatereceipt`,
    { method: 'POST', body: bodyobj },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const sendEPO = async (mail: any) => {
  const TempAccessToken = QAToken;

  return await client1(
    `agreement/epo/mail`,
    { method: 'POST', body: mail },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const GetAgreementactivity = async (agreementId: string) => {
  /* eslint-disable no-console */
  console.log('QA TOKEN', QAToken);
  /* eslint-enable no-console */
  /* eslint-disable no-console */
  console.log('agrid', agreementId);
  /* eslint-enable no-console */
  const TempAccessToken = QAToken;
  try {
    return await client1(
      `agreement/activity/${agreementId}`,
      { method: 'GET' },
      appConfig.apiUrls.micro,
      TempAccessToken
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return 'Error';
  }
};

export const GetLegalHold = async (customerId: string) => {
  /* eslint-disable no-console */
  console.log('Inside Getlegal Hold', customerId);
  const TempAccessToken = QAToken;
  try {
    return await client1(
      `customer/${customerId}/legal-hold`,
      { method: 'GET' },
      customerBaseURL,
      TempAccessToken
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log('Inside legal hold', err);
    /* eslint-enable no-console */
    return 'Error';
  }
};

export const GetCustomerId = async (GCID: string) => {
  const TempAccessToken = QAToken;
  try {
    return await clientCall(
      `customer/${GCID}/detail`,
      { method: 'GET' },
      customerBaseURL,
      TempAccessToken
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return 'Error';
  }
};
export const Getglobalcustomerid = async (customerId: string) => {
  const TempAccessToken = QAToken;
  try {
    return await clientCall(
      `customer/${customerId}/detail`,
      { method: 'GET' },
      customerBaseURL,
      TempAccessToken
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return 'Error';
  }
};
export const updatecustomer = async (addaddress: any) => {
  const TempAccessToken = QAToken;
  try {
    return await clientCall(
      `customer/post-no-decision`,
      { method: 'POST', body: addaddress },
      customerBaseURL,
      TempAccessToken
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return 'Error';
  }
};

export const FindCoCustomer = async (searchdata: any) => {
  const TempAccessToken = QAToken;

  return await client1(
    `agreement/co-customer/search`,
    { method: 'POST', body: searchdata },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const InsertCocustomer = async (insertdata: any) => {
  const TempAccessToken = QAToken;

  return await clientCall(
    `agreement/co-customer/add`,
    { method: 'POST', body: insertdata },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const UpdateVoidStatus = async (voidobj: any) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/void/update`,
    { method: 'PUT', body: voidobj },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
//VA_14
export const GetVoidReasons = async (voidreasons: any) => {
  const TempAccessToken = QAToken;

  return await client1(
    `agreement/void/update`,
    { method: 'PUT', body: voidreasons },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
//get delivery address component
export const GetDeliveryAddress = async (customerId: string) => {
  const TempAccessToken = QAToken;

  return await clientCall(
    `agreement/delivery/${customerId}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
//GetTimeSlots component
export const GetTimeSlots = async (bodyobj: any) => {
  const TempAccessToken = QAToken;

  return await clientCall(
    `agreement/timeslots`,
    { method: 'POST', body: bodyobj },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const GetEnvelopeID = async (parameters: any) => {
  const TempAccessToken = QAToken;
  return await client1(
    '/ess-rest-test.cloudhub.io/esignature/envelopes',
    { method: 'POST', body: parameters },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const LoadDeliveryreceipt = async (agreementId: string) => {
  const TempAccessToken = QAToken;
  return await client1(
    `agreement/delivery/receipt/${agreementId}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
export const LoadswitchoutDeliveryreceipt = async (agreementId: string) => {
  const TempAccessToken = QAToken;
  return await client1(
    `agreement/delivery/receipt/${agreementId}?isSwitchOut=1`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
export const Confirmdelivery = async (updatedeliverystatus: any) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/delivery/status/update`,
    { method: 'PUT', body: updatedeliverystatus },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};
//  function added to confirm delivery for switchout
export const Confirmswitchout = async (updatedeliverystatus: any) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/delivery/status/update`,
    { method: 'PUT', body: updatedeliverystatus },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const Recieptsign = async (updatesign: any) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/delivery/receipt/sign`,
    { method: 'PUT', body: updatesign },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const CheckSign = async (agreementId: string) => {
  const TempAccessToken = QAToken;
  return await client1(
    `agreement/delivery-receipt/sign/check/${agreementId}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const FinishdeliveryStatus = async (complete: any) => {
  const TempAccessToken = QAToken;

  return await clientCall(
    `agreement/delivery`,

    { method: 'POST', body: complete },

    appConfig.apiUrls.micro,

    TempAccessToken
  );
};
// export const GetTimeSlots = async (bodyobj: any) => {
//   const TempAccessToken = QAToken;

//   return await client1(
//     `agreement/timeslots`,

//     { method: 'POST', body: bodyobj },

//     BaseUrl,

//     TempAccessToken
//   );
// };
export const GetCustomerinfo = async (agreementId: string) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/customers/${agreementId}`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const getCurrentUser = (): Promise<any> =>
  client('users/current', { method: 'GET' }, appConfig.apiUrls.container, true);

export const getUserPreferences = (productType: string) =>
  client(
    `users/current/preferences/${productType}`,

    { method: 'GET' },

    appConfig.apiUrls.container
  );

// export const getUserPermissions = (productType: string): Promise<any> =>
//   client(
//     `users/current/permissions/${productType}`,

//     { method: 'GET' },

//     appConfig.apiUrls.container
//   );

export const setUserPreferences = (
  productType: string,

  payload: Record<string, any>,

  cancelToken?: CancelToken
) =>
  client(
    `users/current/preferences/${productType}`,

    {
      method: 'PATCH',

      body: [payload],

      cancelToken,
    },

    appConfig.apiUrls.container
  );

export const getUserStores = () =>
  client(
    'users/current/stores?q=permissions[:includes]=RACPAD_DAP',

    { method: 'GET' },

    appConfig.apiUrls.container
  );

// export const getSearchParams = () =>
// client(
//   'users/current/stores?q=permissions[:includes]=RACPAD_DAP',

//   { method: 'GET' },

//   appConfig.apiUrls.container
// );

// export const getInventorySearch = async (payload: any) => {
//   // eslint-disable-next-line no-console
//   console.log('payload', payload);

//   return await client1(
//     'inventory/search',

//     { method: 'POST', body: payload },
//     InventoryBaseUrl,
//     QAToken,
//     true
//   );
// };
export const getSearchParams = async (param) => {
  return await clientCall(
    `inventory/search-params/${param}`,

    { method: 'GET' },

    InventoryBaseUrl,

    QAToken,

    true
  );
};

export const getCompetitors = async () => {
  return await clientCall(
    '/agreement/competitors',
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getPackageDropdown = async (payload: any) => {
  try {
    return await clientCall(
      'inventory/package/list',

      { method: 'POST', body: payload },
      InventoryBaseUrl,
      QAToken,
      true
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return 'Error';
  }
};
export const getItemPricing = (payload: any) =>
  client1(
    'agreement/package-item/price',

    { method: 'POST', body: payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );

export const getAgreementDelivery = async (agreementId: any, appointmentId?: any) => {
  return await clientCall(
    `agreement/delivery/info/${agreementId}?appointmentId=${appointmentId}`,
    { method: 'Get' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getPricingClientCall = async (Payload: any) => {
  return await clientCall(
    'agreement/package-item/price',
    { method: 'POST', body: Payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const getLegalPriceClientCall = async (payload: any) => {
  return await clientCall(
    'legal/price',
    { method: 'POST', body: payload },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};

export const RunDE = async (payload: any) => {
  return await clientCall(
    `customer/decision-engine`,
    { method: 'POST', body: payload },
    customerBaseURL,
    QAToken,
    true
  );
};

export const GetRemoteLoginStatus = async (Payload: any) => {
  return await clientCall(
    `cashmgmt/duo/auth`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.cashmgmt,
    QAToken,
    true
  );
};
export const getFitmentApi = async (payload: any) => {
  try {

    return await clientCall(
      `agreement/customerorder/search`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.micro,
      QAToken,
      true
    );
  } catch (error: any) {

    /* eslint-disable no-console */
    console.log(error);
    /* eslint-enable no-console */
  }
}
export const getProductAPI = async (payload: any) => {
  try {
    return await clientCall(
      `agreement/customerorder/search`,
      { method: "POST", body: payload },
      appConfig.apiUrls.micro,
      QAToken,
      true
    );
  } catch (error: any) {
    /* eslint-disable no-console */
    console.log(error);
    /* eslint-enable no-console */
  }
};
export const getStoreActionsItem = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `cashmgmt/drawer/audit/info`,
      { method: "POST", body: payload },
      appConfig.apiUrls.cashmgmt,
      QAToken,
      true
    );
  } catch (err: any) {
    return err;
  }
};
export const storeException = async (Payload: any) => {
  const TempAccessToken = QAToken;
  return await clientCall(
    `agreement/store/exception`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.micro,
    TempAccessToken
  );
};

export const getpaymentHistory = async (customer_id: string, type: string, offset: any) => {
  const TempAccessToken = QAToken;
  try {
    return await clientCall(
      `payment1/details/history/${customer_id}?type=${type}&limit=10&offset=${offset}`,
      {
        method: "GET",
      },
      appConfig.apiUrls.payment,
      TempAccessToken
    );
  } catch (err: any) {
    return "Error";
  }
};

export const GetCustomerRewardProfile = async (payload: any) => {
  try {
    return await clientCall(
      `customer/rewards`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.customer,
      QAToken,
      true
    );
  } catch (error: any) {
    console.log("Error in GetCustomerRewardProfile: ", error?.message);
    return "Error";
  }
};

export function getClassifications() {
  return clientCall(
    'classifications/processed',
    { method: 'GET' },
    appConfig.apiUrls.mpo,
    QAToken,
    true
  );
}

// New RACAPI classifications endpoint (POST /classification)
// Used when EnablePricingProductClassifications flag is enabled (1)
export function getPricingClassifications(payload: { storeNumber: string[] }) {
  return clientCall(
    'classification',
    { method: 'POST', body: payload },
    appConfig.apiUrls.mpo,
    QAToken,
    true
  );
}
export function getPricing(payload: any) {
  
  return clientCall(
    'pricing-summary',
    { method: 'POST', body: payload },
    appConfig.apiUrls.mpo,
    QAToken,
    true
  );
}

export function getProductCatalogMatch(payload: any) {
  return clientCall(
    'product-catalog',
    { method: 'POST', body: payload },
    appConfig.apiUrls.mpo,
    QAToken,
    true
  );
}

export async function determineProductLeasability(payload: any) {
  return albCall(
    'productLeasable',
    { requestType: 'POST', body: payload },
    appConfig.apiUrls.leasability,
    QAToken,
    true
  );
}

export async function determineImageLeasability(payload: any) {
  return albCall(
    'imageLeasable',
    { requestType: 'POST', body: payload },
    appConfig.apiUrls.leasability,
    QAToken,
    true
  );
}



// let leaseStub: number = 0;
export async function determineLeasability(payload: any) {

  return clientCall(
    'determine-leasability',
    { method: 'POST', body: payload },
    appConfig.apiUrls.mpo,
    QAToken,
    true
  );
  
}

const delay = (timeToDelay) : Promise<void> => {
  return new Promise<void>((resolve) => {
    setTimeout( resolve, timeToDelay );
  });
}

// Prefund stub — commented out, replaced by real generateFunding call
// let prefundStub: number = 0;
// export async function prefundCard(payload: any) : Promise<any>{
//   prefundStub = prefundStub + 1;
//   const success = { data: { success: '1', mesage: 'successfully Prefunded Card!' }, status: 200 }
//   const failure = { data: { success: '0', mesage: 'Unable to Prefunded Card!' }, status: 500 }
//   const out = prefundStub > 4 ? failure : success;
//   if ( prefundStub > 4 ) prefundStub =0;
//   await delay(5000);
//   return out;
// }

/**
 * Generate funding — calls the prefund/generate-funding endpoint to create a Ramp card spend limit.
 * Only call after leasability confirmed AND pricing resolved.
 */
export function generateFunding(payload: any) {
  return clientCall(
    'generate-funding',
    { method: 'POST', body: payload },
    appConfig.apiUrls.mpo,
    QAToken,
    true
  );
}

// Alias for backward compatibility — prefundCard maps to generateFunding
export const prefundCard = generateFunding;

/**
 * Response shape from the funding transaction status endpoint.
 * Mirrors backend LocalSourceTransactionStatusResponse.
 */
export interface TransactionStatusResponse {
  spendLimitId: string;
  status: string; // "APPROVED" | "DECLINED" | "STARTED" | "UNKNOWN"
  approvalLimitAmount: string;
}

/**
 * Request item shape for ramp purchase confirmation response.
 */
export interface LocalSourceGetSpendLimitDetailRequestItem {
  readonly fundingRequestItemId: string;
  readonly itemNumber: string | null;
  readonly modelNumber: string | null;
  readonly quantity: string | null;
  readonly amount: string | null;
  readonly cashPrice: string | null;
  readonly weeklyRate: string | null;
  readonly weeklyTerm: string | null;
  readonly totalCost: string | null;
}

export interface LocalSourceGetSpendLimitDetailResponse {
  readonly fundingRequestId: string;
  readonly spendLimitId: string;
  readonly vendorName: string;
  readonly requestedAmount: string;
  readonly storeNumber: string;
  readonly usedAmount: string;
  readonly employeeId: string;
  readonly emailAddress: string;
  readonly globalCustomerId: string;
  readonly purchaseOrderNumber: string | null;
  readonly agreementNumber: string | null;
  readonly fundingStatusType: string;
  readonly fundingOriginId: string;
  readonly fundingUserId: string;
  readonly agreementCashPrice?: string | null;
  readonly agreementWeeklyRate?: string | null;
  readonly agreementWeeklyTerm?: string | null;
  readonly agreementTotalCost?: string | null;
  readonly requestItems: LocalSourceGetSpendLimitDetailRequestItem[];
}
/**
 * Response shape from the /purchase-orders/ramp-confirmation endpoint.
 * Used to verify whether the Ramp purchase was confirmed after checkout.
 */
export interface ProcessRampPurchaseConfirmationResponse {
  readonly confirmed: boolean;
  readonly fundingRequestId: string;
  readonly spendLimitId: string;
  readonly purchaseOrderNumber: string | null;
  readonly fundingStatusType: string;
  readonly requestedAmount: string;
  readonly usedAmount: string;
  readonly storeNumber: string;
  readonly vendorName: string;
  readonly globalCustomerId: string;
  readonly requestItems: LocalSourceGetSpendLimitDetailRequestItem[];
}

/**
 * Gets the full funding detail for a spend limit ID.
 * Used for post-checkout verification — polls until confirmed === true.
 */
export function getSpendLimitDetail(spendLimitId: string) {
  return clientCall(
    'purchase-orders/ramp-confirmation',
    { method: 'POST', body: { spendLimitId } },
    appConfig.apiUrls.mpo,
    QAToken,
    true
  );
}

let finalizeStub: number = 0;
export async function finalizePrefunding(payload: any) :  Promise<any> {
  const success = {
    data: {
      status: 200,
      success: '1',
      mesage: 'successfully finalized prefunding'
    }
  }
  
  const failure = {
    data: {
      status: 500,
      success: '0',
      mesage: 'Unable to finalized prefunding!'
    }
  }
  
  const out = finalizeStub > 4 ? failure : success;
  if ( finalizeStub > 4 ) finalizeStub =0;

  await delay();
  return out;

}

 
export const getCustomerAppointment = async (payload: any) => {
  return await getSalesPersonOptions1(payload); // horribly named fx
}

export const fetchOrganizationDetails = async (Payload: any) => {
  return await clientCall(
    `hierarchy`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.pricing
  );
};


export const getSalesPersonOptions1 = async (Payload: any) => {
  
  return await clientCall(
    `/event/search`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.storemgmt,
    "QAToken",
    true
  );
};



export const SendDOFLink = async (Payload: any) => {
  return await clientCall(
    `intellicheck/sendlink`,
    { method: "POST", body: Payload },
    customerBaseURL,
    "QAToken",
    true
  );
};
export const GetCustomerStgData = async (stgCustomerProfileId: string) => {
  return await clientCall(
    `fetch/${stgCustomerProfileId}`,
    { method: 'Get' },
    customerBaseURL,
    QAToken,
    true
  );
};

// Updates the staging identity record via the /manage endpoint. Used to stamp the
// agreementId after a NAAT auto-pass, and to mark selfieVerificationStatus APPROVED
// (with livenessChecked 1) after a Call Center manual selfie authorization.
// All existing identity fields are echoed back to avoid NOT NULL violations.
export const ManageCustomerStgData = async (
  stgCustomerProfileId: string,
  stgCustomerIdentityId: string,
  existingIdentityData: any,   // full latest identity record from /fetch
  updates: {
    agreementId?: string;
    livenessChecked?: number;
    selfieVerificationStatus?: string;
  } = {}
) => {
  return await clientCall(
    `manage`,
    {
      method: 'POST',
      body: {
        action: stgCustomerProfileId ? 'UPD' : 'CRT',
        stgCustomerProfileId,
        identityInfo: {
          stgCustomerIdentityId,
          curpId: existingIdentityData?.curpId || undefined,
          voterId: existingIdentityData?.voterId || undefined,
          rfcId: existingIdentityData?.rfcId || undefined,
          transactionGuid: existingIdentityData?.transactionGuid || null,
          transactionDate: existingIdentityData?.transactionDate || null,
          livenessChecked: updates.livenessChecked ?? 1,          // required — NOT NULL
          identityVerificationStatus: existingIdentityData?.identityVerification || undefined,
          idValidationType: existingIdentityData?.idValidationType || undefined,
          selfieValidationType: existingIdentityData?.selfieValidationtType || undefined,
          selfieVerificationStatus: updates.selfieVerificationStatus ?? existingIdentityData?.selfieVerificationStatus ?? undefined,
          agreementId: updates.agreementId || existingIdentityData?.agreementId || undefined
        }
      }
    },
    customerBaseURL,
    QAToken,
    true
  );
};


export const getReferenceData = async (entity = 'state_province') => {
  return await clientCall(
    `references/entity?referenceCode=${entity}`,
    { method: 'GET' },
    appConfig.apiUrls.am,
    QAToken,
    true
  );

};

export const GetCustomerLoyaltyProgram = async (gcid: any) => {
  try {
    return await clientCall(
      `customer/loyalty/profile/${gcid}?lob=RTO&programName=RAC Loyalty Rewards`,
      { method: "GET" },
      appConfig.apiUrls.customer,
      QAToken
    );
  } catch (error: any) {
    console.log("Error in CustomerLoyaltyProgram: ", error?.message);
    return null;
  }
}

export const GetCustomerEligiblePromotion = async(payload: CustomerEligiblePromotionsRequest) => {
  try {
    return await clientCall(
      `agreement/eligible/promotion`,
      { method: "POST", body: payload },
      appConfig.apiUrls.micro,
    );
  } catch (error: any) {
    console.log("Error in CustomerLoyaltyProgram: ", error?.message);
    return null;
  }
};

export const getVerificationDocuments = async (payload: any) => {

  try {
    return await client(
      `agreement/document/print`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.micro,
    );
  } catch (e: any) {
    return null;
  }
};

export const getStoreDetailsByNumber = async (storeNumber: string) =>{
  return await clientCall(
    `stores/${storeNumber}/details`,
    { method: 'GET' },
    appConfig.apiUrls.am,
    QAToken,
    true
  );
};
 

export const getRetailerLaunchOptions = async () => {
  return await clientCall(
    `launch-opts`,
    { method: 'GET' },
    appConfig.apiUrls.micro,
    QAToken,
    true
  );
};
